import type { VisitDisplay } from "../types";

/** Real visit IDs represented by one chronology row (collapsed therapy expands to all underlying). */
export function getSelectableVisitIds(visit: VisitDisplay): string[] {
  if (visit.allVisits?.length) {
    return visit.allVisits.map((v) => v.visit_id);
  }
  return [visit.visit_id];
}

export function collectSelectableIdsFromVisits(visits: VisitDisplay[]): string[] {
  return visits.flatMap((v) => getSelectableVisitIds(v));
}

export function countSelectedInIds(selected: ReadonlySet<string>, ids: string[]): number {
  return ids.reduce((n, id) => n + (selected.has(id) ? 1 : 0), 0);
}

export function getCheckboxAggregateState(
  selected: ReadonlySet<string>,
  ids: string[]
): { checked: boolean; indeterminate: boolean } {
  if (ids.length === 0) return { checked: false, indeterminate: false };
  const selectedCount = countSelectedInIds(selected, ids);
  if (selectedCount === 0) return { checked: false, indeterminate: false };
  if (selectedCount === ids.length) return { checked: true, indeterminate: false };
  return { checked: false, indeterminate: true };
}
